export const StreamGrouping = {
    ALL: 'ALL',
    PRODUCT: 'PRODUCT',
};
